import React, { Component } from 'react'
import _, { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import './select.scss';

import asyncRoute from '../../../helpers/hoc/asyncRoute';
import Error from '../error';

const Tooltip = asyncRoute(() => import('../../../components/FormElements/ToolTip'));
const InfoButton = asyncRoute(()=> import('../../InfoButton'));

export default class index extends Component {
  render() {
    const { onChange, disabled, onBlur, setting, submited, touched, error, value, toggle, options, infoIcon = false, onInfoClick=()=>{} } = this.props;
    const { labelLayout = 'col-sm-4', valueKey = 'id', textKey = 'value', addModel = false, editModel = false, divLayout="", addBreakOptional=true,infoStyle,showOptional=true } = setting
    return (
      <div className={`form-group row ${divLayout}`}>
        {setting.label && <label htmlFor={setting.key} className={`${labelLayout} col-form-label`}>{setting.label}{" "}{(setting.required) ? <span className='text-danger'>*</span> : showOptional && <>
        {
          !setting.required && addBreakOptional &&
           <InfoButton 
           infoIcon={infoIcon}
           onInfoClick={onInfoClick}
           infoStyle={infoStyle}
           />
        }
        {addBreakOptional && <br />}<span className="small" style={{ color: "#1925238a" }}>Optional</span></>}
        {
          (setting.required || !addBreakOptional) &&
           <InfoButton 
           infoIcon={infoIcon}
           onInfoClick={onInfoClick}
           infoStyle={infoStyle}
           />
        }
        </label>}
        <div className={setting.displayLayout}>
          <select
            id={setting.key}
            className={isEmpty(error) ? "form-select" : "form-select has-error"}
            onChange={(event) => { onChange(event); onBlur(event); }}
            onBlur={onBlur}
            value={value}
            name={setting.key}
            disabled={disabled}
            style={{ width: "100%", height: "auto" }}
          >
            <option selected disabled value="">{setting.placeholder || 'Select'}</option>
            {_.map(options, (item, index) => (
              <option key={index} value={item[valueKey]} disabled={!!item.disabled}>{item[textKey]}</option>)
            )}
          </select>
          {(submited || touched) && (<Error setting={setting} error={error} />)}
        </div>
        {setting.tooltip && <Tooltip text={setting.tooltip} />}
        {addModel && <i onClick={() => toggle('add')} className="mdi mdi-plus-box mdi-24px btnSelectCursor"></i>}
        {editModel && <i onClick={() => toggle('edit')} className={`${value === '' ? 'disabled' : ''}  mdi mdi-pencil-box mdi-24px btnSelectCursor`}></i>}
      </div>
    )
  }
}

// -----* select propTypes set  *----
index.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  options: PropTypes.array,

  // -----* setting PropTypes *----
  setting: PropTypes.shape({
    required: PropTypes.bool,
    label: PropTypes.string,
    key: PropTypes.string,
    placeholder: PropTypes.string,
    tooltip: PropTypes.string,
    touched: PropTypes.object
  }),
}